import { Component, EventEmitter, input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionEvent, StandardAction } from '@infodata-group/inf-commons';

@Component({
  selector: 'infl-title',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './title.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './title.component.scss',
})
export class TitleComponent {
  public title = input.required<string>();
  public actions = input<StandardAction[]>([]);

  @Output() actionClick = new EventEmitter<ActionEvent>();

  onActionClick(action: StandardAction) {
    if (!action.enable) {
      return;
    }
    this.actionClick.emit(new ActionEvent('click', action, null));
  }
}
